import createVueApp from '@/common/create_app'

Styxie.Initializers.StatsKeywords = {
  index: async(props) => {
    const { default: Keywords } = await import('@/vue_widgets/locations/keywords')
    createVueApp(Keywords, {
      props: {
        keywordsData: { ...props, isPublic: true }
      }
    })
  }
}
